// extracted by css-extract-rspack-plugin
export default {"cls1":"ViewAllSuggestions-cls1_HY5","cls2":"ViewAllSuggestions-cls2_Zd0 ViewAllSuggestions-cls1_HY5"};